import { alpha, createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';

export const styles = ({ shape, spacing }: Theme) =>
  createStyles({
    cardWrap: {
      background: colors.white.lightest,
      backgroundClip: 'padding-box',
      border: `1px solid ${colors.grey.light}`,
      borderRadius: shape.borderRadius,
      clear: 'both',
      cursor: 'pointer',
      display: 'flex',
      margin: 0,
      padding: '17px 30px',
      userSelect: 'none',

      '&:not(:first-of-type)': {
        marginTop: spacing(4),
      },

      '&:hover': {
        boxShadow: `0 2px 9px ${alpha(colors.blue.medium, 0.15)}`,
        cursor: 'pointer',
      },
    },

    imageWrap: {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 80px',
      marginRight: 8,
      marginLeft: -9,
      width: 80,
    },

    header: {
      color: colors.black.darkest,
      fontSize: 16,
    },
    text: {
      color: colors.grey.main,
    },
  });
